export default __webpack_public_path__ + "assets/e293ed404de4ee15ffc44128d5a2ac45.png";